import { builder } from '../../../common/js/config/index';
import { inArticleCommonConfig } from './common-config-in-article-video';

export const inArticleRevealConfig = {
  ...inArticleCommonConfig,
  skin: builder.holder({
    visibleByDefault: builder.boolean('skins_visible_by_default', {
      optional: true,
      defaultValue: true,
      label: 'Skins visible by default',
      description:
        'Can have the skins visible by default (when ad is not expanded)'
    })
  })
};
